import { render, staticRenderFns } from "./UkerportalLogo.vue?vue&type=template&id=389b98fa&"
import script from "./UkerportalLogo.vue?vue&type=script&lang=js&"
export * from "./UkerportalLogo.vue?vue&type=script&lang=js&"
import style0 from "./UkerportalLogo.vue?vue&type=style&index=0&id=389b98fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports